const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

const merchantCenterRouter = {
  path: '/property/merchant',
  component: index,
  children: [
    {
      path: 'center/overview',
      name: 'merchantOverview',
      component: () => import('@/pages/property/merchants/merchantCenter/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '招商中心',
      },
    },
    {
      path: 'center/create',
      name: 'merchantCreate',
      component: () => import('@/pages/property/merchants/merchantCenter/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '新增商机',
      },
    },
    {
      path: 'center/edit',
      name: 'merchantEdit',
      component: () => import('@/pages/property/merchants/merchantCenter/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '编辑商机',
      },
    },
    {
      path: 'center/detail',
      name: 'merchantDetail',
      component: () => import('@/pages/property/merchants/merchantCenter/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '商机详情',
      },
    },
    {
      path: 'commission/overview',
      name: 'commissionOverview',
      component: () => import('@/pages/property/merchants/commission/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '佣金规则设置',
      },
    },
    {
      path: 'commissionDetail',
      name: 'commissionDetail',
      component: () => import('@/pages/property/merchants/commission/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '佣金规则详情',
      },
    },
    {
      path: 'commissionAudit',
      name: 'commissionAudit',
      component: () => import('@/pages/property/merchants/commission/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '审核佣金规则',
      },
    },
    {
      path: 'reward/overview',
      name: 'rewardOverview',
      component: () => import('@/pages/property/merchants/reward/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '招商奖励结算',
      },
    },
    {
      path: 'reward/detail',
      name: 'rewardDetail',
      component: () => import('@/pages/property/merchants/reward/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '结算详情',
      },
    },
    {
      path: 'reward/detail',
      name: 'rewardAudit',
      component: () => import('@/pages/property/merchants/reward/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '审核招商奖励',
      },
    },
  ],
};

export default merchantCenterRouter;
